import { jsx as f } from "react/jsx-runtime";
import "react";
import { classNames as a } from "../../utilities/index.js";
const c = ({ type: i = "ul", bullets: s, inside: t, layout: e, children: o, className: n, ...l }) => {
  const r = a({
    "sash-List": !0,
    "m-0 p-0 list-none": s === "none",
    "list-disc": s === "disc" || !s && i === "ul",
    "list-decimal": s === "decimal" || !s && i === "ol",
    "list-inside": t,
    "flex flex-wrap [&>*]:flex-1": e === "fluid",
    "flex flex-wrap [&>*]:flex-none": e === "inline",
    [n]: n
  });
  return /* @__PURE__ */ f(
    i,
    {
      className: r,
      ...l,
      children: o
    }
  );
}, L = c;
export {
  L as default
};
